/*
 | -------------------------------------------------------------
 |  --> type: component
 |  --> name: navigation tabs
 | -------------------------------------------------------------
 |
 |  This component uses a set of tabs to display different sets
 |  of content depending on which tab is selected.
 |
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const tabsNav = document.querySelector('.mgbdes__navigation-tabs')
const tabsButtons = tabsNav ? [...tabsNav.querySelectorAll('button')] : []
const tabsContent = [...document.querySelectorAll('[data-tab-content]')]

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

tabsNav && tabsNav.addEventListener('click', event => {
  // only fire event when a tab is clicked
  if (event.target.closest('.navigation-tabs__button')) {
    // get the currently clicked tab
    const button = event.target
    // remove class is active from all tabs
    tabsButtons.forEach(button => button.classList.remove('is-active'))
    // add class is-active to the current tab
    button.classList.add('is-active')
    // get the id from the clicked tab
    const buttonId = button.getAttribute('id')
    // look for the content with the same id as the tab
    tabsContent.forEach(content => {
      const contentId = content.getAttribute('id')
      contentId === buttonId
        // remove hidden from the current tab
        ? content.removeAttribute('hidden')
        // add hidden to all other tabs
        : content.setAttribute('hidden', true)
    })
  }
})
